import { useRouteMatch } from 'react-router'
import type { FileTypeEnum } from 'utils'

import type { MCWithParams } from 'components/uiKit/Modal'
import Modal, { useOpenModal } from 'components/uiKit/Modal'

import FinderFilePicker, { FinderTabsEnum, IFinderFilePickerProps } from '../FinderFilePicker'

type FinderModalParams = Omit<IFinderFilePickerProps, 'onFilePick'>

export const FinderModalPage: MCWithParams<FinderModalParams, string> = ({ onClose, params }) => {
  return (
    <Modal minHeight='100%' name='filePick' styleType='fullScreen'>
      <FinderFilePicker {...params} onFilePick={onClose} />
    </Modal>
  )
}

interface IFilePickerParams {
  defaultContentType: FileTypeEnum
  tabs?: FinderTabsEnum[]
}

export const useFilePickerModal = ({ defaultContentType, tabs }: IFilePickerParams) => {
  const routeMatch = useRouteMatch<{
    projectId?: string
    companyId: string
    fileMetaGroupId?: string
  }>()
  const params = routeMatch.params

  return useOpenModal(FinderModalPage, {
    params,
    defaultContentType,
    tabs,
  })
}
